export const COMPONENT_TOKEN_PREFIX = "--sds--";
//# sourceMappingURL=tokens.js.map